export function sleepAsync(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

type Resolve<T> = (value: T | PromiseLike<T>) => void;
type Reject = (reason?: any) => void;
type PromiseArg<T> = (resolve: Resolve<T>, reject: Reject) => void;

export function withTimeout<T>(
    promise: Promise<T> | PromiseArg<T>,
    ms: number
): Promise<T> {
    if (promise instanceof Function) {
        promise = new Promise(promise);
    }
    return Promise.race([
        promise,
        new Promise<T>((_, reject) => {
            setTimeout(() => reject(new Error('Promise is timed out.')), ms);
        }),
    ]);
}
